<template>
  <q-btn
          v-if="isGranted('EDIT_PAYMENT_METHOD')"
          icon="fa fa-edit"
          title="Edit Payment Method"
          v-bind="$attrs"
          @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { PaymentMethod } from '@/type';
import openModal from '@/components/modal';
import EditPaymentMethodModal from './EditPaymentMethodModal.vue';

export default defineComponent({
  emits: ['updated'],
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { paymentMethod: this.paymentMethod, parent: this };
      openModal(EditPaymentMethodModal, props).onOk((updated: PaymentMethod) => {
        this.$emit('updated', updated);
      });
    },
    isGranted,
  },
});
</script>
